import { render, staticRenderFns } from "./MenuMobile.vue?vue&type=template&id=180120b4&scoped=true&"
import script from "./MenuMobile.vue?vue&type=script&lang=ts&"
export * from "./MenuMobile.vue?vue&type=script&lang=ts&"
import style0 from "./MenuMobile.vue?vue&type=style&index=0&id=180120b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180120b4",
  null
  
)

export default component.exports